import { createIcon } from '../icon'
import RecommendedIcon from '../svg/RecommendedIcon'

export const RecommendedIconDefault = createIcon(RecommendedIcon)
